/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetStoryQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetStoryQuery = { __typename: 'Query', getStory: { __typename: 'Feed', gallery: Array<string> | null, id: string, body: string | null, title: string, argument_type: string, created_at: string, updated_at: string, global_status: Types.GlobalStatus | null, review_status: Types.ReviewStatus | null, properties: string | null, product_id: string | null, campaign_id: number, pinned: boolean | null, pinned_at: string | null, pinned_by: string | null, tags: Array<{ __typename: 'Tag', id: string, label: string, order_number: number }> | null, comments: Array<{ __typename: 'Comment', id: string, text: string, updated_at: string, campaign_id: number, author: { __typename: 'User', first_name: string, last_name: string, label_id: string | null } }> | null, lastEditor: { __typename: 'User', last_name: string, first_name: string, email: string } | null, author: { __typename: 'User', last_name: string, first_name: string, email: string } | null, product: { __typename: 'Product', name: string | null, configuration: string | null } | null, facts: { __typename: 'Fact', chart: string | null, position_current_at: string | null } | null, campaign: { __typename: 'Campaign', id: string | null, name: string | null, owner_id: number | null, unit_id: number | null, label_id: string | null, active: boolean | null, unit: { __typename: 'Unit', id: string, name: string } | null } } };


export const GetStoryDocument = gql`
    query getStory($id: String!) {
  getStory(id: $id) {
    gallery
    id
    body
    title
    argument_type
    created_at
    updated_at
    global_status
    review_status
    properties
    product_id
    campaign_id
    pinned
    pinned_at
    pinned_by
    tags {
      id
      label
      order_number
    }
    comments {
      id
      text
      updated_at
      campaign_id
      author {
        first_name
        last_name
        label_id
      }
    }
    lastEditor {
      last_name
      first_name
      email
    }
    author {
      last_name
      first_name
      email
    }
    product {
      name
      configuration
    }
    facts {
      chart
      position_current_at
    }
    campaign {
      id
      name
      owner_id
      unit_id
      label_id
      active
      unit {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetStoryQuery__
 *
 * To run a query within a React component, call `useGetStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStoryQuery(baseOptions: Apollo.QueryHookOptions<GetStoryQuery, GetStoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoryQuery, GetStoryQueryVariables>(GetStoryDocument, options);
      }
export function useGetStoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoryQuery, GetStoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoryQuery, GetStoryQueryVariables>(GetStoryDocument, options);
        }
export type GetStoryQueryHookResult = ReturnType<typeof useGetStoryQuery>;
export type GetStoryLazyQueryHookResult = ReturnType<typeof useGetStoryLazyQuery>;